// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(3, 7, 18, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: fade-in 0.25s ease-out;
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-container {
  width: 100%;
  max-width: 480px;
  background: #0d1322;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 24px;
  animation: slide-up 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-subtle);
}

.modal-title {
  font-family: var(--font-family);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
}

.modal-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary);
}

/* ── Form Inputs ── */
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input,
.form-select {
  width: 100%;
  padding: 11px 14px;
  background: rgba(255, 255, 255, 0.015);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-size: 0.9rem;
  transition: all 0.25s ease;
}

.form-select option {
  background: #0d1322;
  color: var(--text-primary);
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--border-active);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.08);
}

/* ── Logo Selection Grid ── */
.logo-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  max-height: 160px;
  overflow-y: auto;
  padding: 2px;
}

.logo-option-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 4px;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: rgba(255, 255, 255, 0.01);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  text-align: center;
}

.logo-option-card:hover {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.1);
}

.logo-option-card.selected {
  border-color: var(--accent-emerald);
  background: var(--accent-emerald-glow);
}

.logo-option-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--text-muted);
}

.logo-option-dot--slack { background-color: #ECB22E; }
.logo-option-dot--jira { background-color: #2563eb; }
.logo-option-dot--gmail { background-color: #ef4444; }
.logo-option-dot--drive { background-color: #3b82f6; }
.logo-option-dot--driver-portal { background-color: #fbbf24; }
.logo-option-dot--autocab { background-color: #22c55e; }
.logo-option-dot--nudg { background-color: #06b6d4; }
.logo-option-dot--default { background-color: var(--accent-emerald); }

.logo-option-label {
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.logo-option-card.selected .logo-option-label {
  color: var(--text-primary);
  font-weight: 600;
}

/* ── Actions ── */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid var(--border-subtle);
}

.modal-btn {
  padding: 10px 18px;
  border-radius: var(--radius-md);
  font-size: 0.88rem;
  font-weight: 600;
  transition: all 0.25s ease;
}

.modal-btn--secondary {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
}

.modal-btn--secondary:hover {
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary);
  border-color: rgba(255, 255, 255, 0.1);
}

.modal-btn--primary {
  background: var(--accent-emerald);
  color: #0b0f19;
}

.modal-btn--primary:hover {
  background: var(--accent-emerald-hover);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  transform: translateY(-1px);
}
`, "",{"version":3,"sources":["webpack://./src/components/AddAppModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,0BAA0B,yBAAyB,EAAE;AACrD,yBAAyB,yBAAyB,EAAE;AACpD,0BAA0B,yBAAyB,EAAE;AACrD,0BAA0B,yBAAyB,EAAE;AACrD,kCAAkC,yBAAyB,EAAE;AAC7D,4BAA4B,yBAAyB,EAAE;AACvD,yBAAyB,yBAAyB,EAAE;AACpD,4BAA4B,uCAAuC,EAAE;;AAErE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,2BAA2B;AAC7B","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(3, 7, 18, 0.7);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  animation: fade-in 0.25s ease-out;\n}\n\n@keyframes fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modal-container {\n  width: 100%;\n  max-width: 480px;\n  background: #0d1322;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 24px;\n  animation: slide-up 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.modal-title {\n  font-family: var(--font-family);\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.modal-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-primary);\n}\n\n/* ── Form Inputs ── */\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: 11px 14px;\n  background: rgba(255, 255, 255, 0.015);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-family: var(--font-sans);\n  font-size: 0.9rem;\n  transition: all 0.25s ease;\n}\n\n.form-select option {\n  background: #0d1322;\n  color: var(--text-primary);\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: var(--border-active);\n  background: rgba(255, 255, 255, 0.03);\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.08);\n}\n\n/* ── Logo Selection Grid ── */\n.logo-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  max-height: 160px;\n  overflow-y: auto;\n  padding: 2px;\n}\n\n.logo-option-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 4px;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  background: rgba(255, 255, 255, 0.01);\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  text-align: center;\n}\n\n.logo-option-card:hover {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.logo-option-card.selected {\n  border-color: var(--accent-emerald);\n  background: var(--accent-emerald-glow);\n}\n\n.logo-option-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--text-muted);\n}\n\n.logo-option-dot--slack { background-color: #ECB22E; }\n.logo-option-dot--jira { background-color: #2563eb; }\n.logo-option-dot--gmail { background-color: #ef4444; }\n.logo-option-dot--drive { background-color: #3b82f6; }\n.logo-option-dot--driver-portal { background-color: #fbbf24; }\n.logo-option-dot--autocab { background-color: #22c55e; }\n.logo-option-dot--nudg { background-color: #06b6d4; }\n.logo-option-dot--default { background-color: var(--accent-emerald); }\n\n.logo-option-label {\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.logo-option-card.selected .logo-option-label {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* ── Actions ── */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid var(--border-subtle);\n}\n\n.modal-btn {\n  padding: 10px 18px;\n  border-radius: var(--radius-md);\n  font-size: 0.88rem;\n  font-weight: 600;\n  transition: all 0.25s ease;\n}\n\n.modal-btn--secondary {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-secondary);\n}\n\n.modal-btn--secondary:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-primary);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.modal-btn--primary {\n  background: var(--accent-emerald);\n  color: #0b0f19;\n}\n\n.modal-btn--primary:hover {\n  background: var(--accent-emerald-hover);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n  transform: translateY(-1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
